import { cn } from '#app/utils/misc.tsx'

interface TimeTravelSliderProps {
	label: string
	hint: string
	min: number
	max: number
	value: number
	onChange?: (v: number) => void
	disabled?: boolean
}

/**
 * "What did the books say as of knowledge-time N?" — the control that makes
 * the cost of mutation visible. Live on the immutable book; inert on the
 * mutable one (there is no past to travel to).
 */
export function TimeTravelSlider({
	label,
	hint,
	min,
	max,
	value,
	onChange,
	disabled = false,
}: TimeTravelSliderProps) {
	return (
		<div
			className={cn(
				'rounded-md border p-3 text-left',
				disabled && 'opacity-60',
			)}
		>
			<div className="mb-2 flex items-center justify-between gap-2">
				<span className="text-xs font-medium">{label}</span>
				<span className="text-muted-foreground text-xs">{hint}</span>
			</div>
			<input
				type="range"
				min={min}
				max={Math.max(min, max)}
				value={value}
				disabled={disabled || max <= min}
				onChange={(e) => onChange?.(Number(e.target.value))}
				className="w-full accent-indigo-500 disabled:cursor-not-allowed"
			/>
		</div>
	)
}
